import React from 'react'
import PropTypes from 'prop-types'
import { sizes } from '@qflow/theme'

export function AI({ size = sizes.SMALL, colour = 'currentColor', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="11"
      viewBox="0 0 12 11"
      {...props}
      style={{ width: size, height: size }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.86632 5.33845L3.82176 2.47213H4.40808L5.36352 5.33845L8.22984 6.29389V6.88021L5.36352 7.83565L4.40808 10.702H3.82176L2.86632 7.83565L0 6.88021V6.29389L2.86632 5.33845Z"
        fill={colour}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2741 1.47575L8.76601 0H9.35233L9.84425 1.47575L11.32 1.96767V2.55399L9.84425 3.0459L9.35233 4.52166H8.76601L8.2741 3.04591L6.79834 2.55399V1.96767L8.2741 1.47575Z"
        fill={colour}
      />
    </svg>
  )
}

AI.propTypes = {
  colour: PropTypes.string,
  size: PropTypes.string
}
